import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const VitrineIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ color: 'secondary.main', ...sx }}
    {...props}
  >
    <g clipPath="url(#ArrowUpClipPath)">
      <path
        d="M2.5 10.8333H9.16667V2.5H2.5V10.8333ZM2.5 17.5H9.16667V12.5H2.5V17.5ZM10.8333 17.5H17.5V9.16667H10.8333V17.5ZM10.8333 2.5V7.5H17.5V2.5H10.8333Z"
        fill="inherit"
      />
    </g>
    <defs>
      <clipPath id="ArrowUpClipPath">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
)

VitrineIcon.defaultProps = {
  sx: null,
}
